// extracted by mini-css-extract-plugin
module.exports = {"loader":"spinner_loader__1C49I","spin":"spinner_spin__30kah"};